import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {OptionStyled, OptionInput, OptionText, ExtraPrice} from './Option.style';
import Price from '../Price/Price';

export class Option extends Component {
  constructor(props) {
    super(props);
    this.selectOption = this.selectOption.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const {option, selectedSizeChanged} = nextProps;
    if (selectedSizeChanged && option.defaultOption) {
      // only update the new option which has defaultOption
      this.updateOptionGroupByOption(option.defaultOption, option);
    }
  }

  selectOption(e) {
    e.stopPropagation();
    // the new updated checked status will be opposite the old value
    this.updateOptionGroupByOption(e.target.value !== 'true', this.props.option);
  }

  updateOptionGroupByOption(isChecked, option) {
    const {optionGroupName, multiSelect, onChange} = this.props;
    const updatedOption = {
      group: optionGroupName,
      selection: option.name,
      price: option.price
    };
    onChange(updatedOption, multiSelect, isChecked);
  }

  render() {
    const {option, optionGroupName, multiSelect, isEnabled, isChecked} = this.props;
    const {name, price} = option;
    const renderPrice = price > 0 ? <ExtraPrice><Price amount={price} /></ExtraPrice> : '';

    return (
      <OptionStyled>
        <OptionInput
          type={multiSelect ? 'checkbox' : 'radio'}
          name={optionGroupName}
          value={isChecked}
          onClick={this.selectOption}
          defaultChecked={isChecked}
          disabled={!isEnabled && !isChecked}
        />
        <OptionText isChecked={isChecked}>{name} {renderPrice}</OptionText>
      </OptionStyled>
    );
  }
}

Option.propTypes = {
  option: PropTypes.shape({
    name: PropTypes.string,
    defaultOption: PropTypes.bool,
    price: PropTypes.number
  }).isRequired,
  optionGroupName: PropTypes.string.isRequired,
  multiSelect: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  isChecked: PropTypes.bool.isRequired,
  selectedSizeChanged: PropTypes.bool.isRequired
};

export default Option;



// WEBPACK FOOTER //
// ./components/Meal/Option.js